import { FC, useState } from "react";
import { Input } from "antd";
import cn from "classnames";
import Carrier from "@Components/Carrier/Carrier";
import { SearchIcon, DefaultCheckIcon, PassengerSelectIcon } from "src/assets/Icons";
import { PassengerSelectFieldProps, PassengerSelectOption } from "../PassengerSelectField";

const PassengerSelectOptionsList: FC<{
  options?: PassengerSelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  closeSheet?: () => void;
}> = ({
  options,
  value,
  onChange,
  closeSheet,
}) => {
  const [search, setSearch] = useState("");
  const filteredOptions = (options ?? []).filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="flex flex-col">
      <div className="outline-b outline-border-default shadow-border-default sticky top-0 z-10 w-full bg-background-default p-4 shadow-sm">
        <div className="gap-2! outline-border-default focus-within:outline-border-active flex shrink-0 items-center justify-center rounded-md px-4 outline">
          <SearchIcon className="h-5 w-5 text-current" />
          <Input autoFocus value={search} onChange={(e) => setSearch(e.target.value)} variant="borderless" className="p-4!" />
        </div>
      </div>

      <div className="flex w-full flex-col gap-2 p-3">
        {filteredOptions.map((option) => {
          const isSelected = option.value === value;
          return (
            <div
              key={option.value}
              className={cn(
                "flex w-full cursor-pointer items-center justify-between rounded-sm p-2 font-semibold transition-all duration-300 hover:bg-background-primary-light",
                isSelected && "text-font-active",
              )}
              onClick={() => {
                onChange?.(option.value);
                closeSheet?.();
              }}
            >
              {option.label}
              {isSelected && <DefaultCheckIcon className="h-4 w-4" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const PassengerSelectFieldMob: FC<PassengerSelectFieldProps> = ({ value, onChange, label, placeholder, options }) => {
  const selectedLabel = options?.find((option) => option.value === value)?.label;

  return (
    <Carrier
      label={label ?? placeholder}
      renderTrigger={({ open }) => (
        <div className="border-b border-border-default flex w-full flex-1 items-center gap-2 px-1 text-font-subtle">
          <PassengerSelectIcon className="h-4! w-4!" />
          <Input
            placeholder={placeholder}
            readOnly
            variant="borderless"
            value={selectedLabel}
            onClick={open}
            className="text-font-default! font-semibold shadow-none! px-3! py-2! w-full cursor-pointer"
          />
        </div>
      )}
      renderSheet={({ close }) => <PassengerSelectOptionsList options={options} value={value} onChange={onChange} closeSheet={close} />}
    />
  );
};

export default PassengerSelectFieldMob;
